// extracted by mini-css-extract-plugin
export default {"shimmer":"ProfileDropdown_shimmer__6g0F8","dark_shimmer":"ProfileDropdown_dark_shimmer__pGdGt","dropdown":"ProfileDropdown_dropdown__e8Wx5"};